<div class="flex" style="margin-top: 15px;" *ngIf="properties && totalProperties > 0">
  <div class="card w-full">
    <div class="p-datatable p-component p-datatable-hoverable-rows">
      <p-table
        [(first)]="first"
        [(rows)]="rows"
        [value]="properties"
        [totalRecords]="totalProperties"
        [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
        [paginator]="true"
        [rowsPerPageOptions]="[10,25,50]"
        styleClass="p-datatable-striped"
        sortField="name"
        dataKey="uuid"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="w-18rem" pSortableColumn="name">
              {{'attribute.name' | transloco}}<p-sortIcon field="name"></p-sortIcon></th>
            <th pSortableColumn="value">
              {{'attribute.value' | transloco}}<p-sortIcon field="value"></p-sortIcon></th>
            <th pSortableColumn="propertyType.name">
              {{'model.propertyType' | transloco}}<p-sortIcon field="propertyType.name"></p-sortIcon></th>
            <th pSortableColumn="propertyType.unit">
              {{'model.measurementUnit' | transloco}}<p-sortIcon field="propertyType.unit"></p-sortIcon></th>
            <th pSortableColumn="propertyType.dataType">
              {{'attribute.dataType' | transloco}}<p-sortIcon field="propertyType.dataType"></p-sortIcon></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-property>
          <tr *ngIf="!loadingProperties">
            <td>
              <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
              <p class="text-right md:text-left" style="word-break: break-all;">{{property.name}}</p>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.value' | transloco}}</span>
              {{property.value}}
            </td>
            <td>
              <span class="p-column-title bold">{{'model.propertyType' | transloco}}</span>
              {{property.propertyType?.name ?? ''}}
            </td>
            <td>
              <span class="p-column-title bold">{{'model.measurementUnit' | transloco}}</span>
              {{property.propertyType?.unit ?? ''}}
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.dataType' | transloco}}</span>
              {{property.propertyType?.dataType ?? ''}}
            </td>
          </tr>
          <tr *ngIf="loadingProperties">
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="flex align-items-center justify-content-between" *ngIf="totalProperties == 0">
            {{'pagination.empty' | transloco}}
          </div>
          <div class="flex align-items-center justify-content-between" *ngIf="totalProperties > 0">
            {{'pagination.showing' | transloco}} {{first+1}}
            {{'pagination.to' | transloco}} {{(first+rows) >= totalProperties ? totalProperties : (first+rows)}}
            {{'pagination.of' | transloco}} {{totalProperties}}
            {{(totalProperties > 1 ? 'pagination.entries':'pagination.entry') | transloco}}
          </div>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<div class="flex" style="margin-top: 15px;" *ngIf="properties && totalProperties == 0">
  <div class="card w-full"><p class="text-xl text-center p-6 font-italic">{{'empty.properties' | transloco}}</p></div>
</div>
<div class="flex" style="margin-top: 15px;" *ngIf="!defaultDeviceCatalog || !properties">
  <div class="card w-full">
    <app-table-skeleton [rows]="14"></app-table-skeleton>
  </div>
</div>
